import { IconButton } from '@mui/material';
import { ReactComponent as GmailIcon } from '../img/gmail.svg';

export default function GmailContact() {

const handleGmail = (e) => {
    let recipient = "Advisor@tradetogether.com"
    let subject = "Withdrawal Request"
    let mailtoLink = `mailto:${recipient}`;
    const isMobileDevice = isMobile()
    if(isMobileDevice) {
        window.open(mailtoLink)
    } else {
        window.open(`https://mail.google.com/mail/?view=cm&fs=1&to=${recipient}&su=${encodeURIComponent(subject)}`)
    }
}

const isMobile = () => {
    let details = navigator.userAgent; 
    let regexp = /android|iphone|kindle|ipad/i; 
    let isMobileDevice = regexp.test(details); 
    if (isMobileDevice) { 
        return true 
    } else { 
        return false
    }
}
  return (
    <IconButton onClick={handleGmail} style={{marginRight:"8px"}}><GmailIcon style={{width:"30px"}}/></IconButton>
  )
}
